<template>
  <div class='institutional-qnr-results-view view p-6'>
      <router-view
        v-if='filteredSections && filteredSections.length > 0'
        :clientGroupID='clientGroupID'
        :sections='filteredSections'
        :prospects='this.prospects'
        :assignedColors='assignedColors'/>

      <b-loading :is-full-page='true' v-model='isLoading' :can-cancel='true'>
        <b-icon
            pack='fa'
            icon='sync'
            size='is-large'
            custom-class='fa-spin'>
        </b-icon>
      </b-loading>
  </div>
</template>


<script>
import { getQuestionnaireQuestions } from '@frontend/api/questionnaireApi';

export default {
  name: 'institutional-qnr-results-view',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return {
      clientGroupID: null,
      clientGroupQuestions: [],
      responses: [],
      sectionsWithResponses: [],
      qnr: {},
      isLoading: true,
    };
  },
  beforeCreate() {},
  async created() {
    this.isLoading = true;
    const groupId = this.$route.query.group;
    if (!groupId) {
      this.isLoading = false; return;
    }
    this.clientGroupID = groupId;

    // originally computed
    this.qnr = (await getQuestionnaireQuestions('inst-qnr-v1')).data.questionnaire;
    // will want questionnaire type path to be dynamic, but this is fine for now
    const responses = (await (await fetch(`/api/v1/questionnaire/inst-qnr-v1/group/responses/${groupId}`)).json()).responses;
    this.responses = responses.map(response => ({ name: response.name, responses: { ...response.response.answers } }));
    this.prospects = responses.map(response => response.prospect);
    // originally computed
    // everything below here in this function seems like it's unnecessary and verbose- could probably be done in 1 or two lines
    const res = {};
    this.responses.forEach(r => {
      const name = r.name;
      Object.keys(r.responses).forEach(slug => {
        if (!res[slug]) res[slug] = [];
        res[slug].push({ name, response: r.responses[slug] });
      });
    });
    // originally computed
    this.sectionsWithResponses = this.sections.map(s => {
      const section = { ...s };
      section.questions = s.questions.map(q => {
        const question = { ...q };
        question.responses = res[q.slug];
        return question;
      });
      return section;
    });
    this.isLoading = false;
  },
  mounted() {},
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    sections() {
      return this.qnr.sections;
    },
    people() {
      return this.responses.map(r => r.name);
    },
    peopleSorted() {
      const names = this.people.map(p => {
        const parts = p.split(' ');

        return {
          last: parts[parts.length - 1].toLowerCase(),
          full: p,
        };
      });

      const sorted = names.sort((a, b) => {
        if (a.last > b.last) return 1;
        if (a.last < b.last) return -1;
        return 0;
      });

      return sorted.map(p => p.full);
    },
    assignedColors() {
      const colors = this.$root.$data.COLORS.assorted;
      const assigned = {};

      this.people.forEach((name, i) => {
        const n = i % colors.length;
        assigned[name] = colors[n];
      });
      return assigned;
    },
    allowedQuestions() {
      const slugs = this.clientGroupQuestions;
      if (!slugs?.length) return null;
      
      const allowed = {};
      slugs.forEach(s => allowed[s] = true);
      return allowed;
    },
    filteredQuestions() {
      if (!this.allowedQuestions) return this.sectionsWithResponses;

      return this.sectionsWithResponses?.map(section => {
        return {
          ...section,
          questions: section.questions.filter(q => {
            return this.allowedQuestions[q.slug]
          }),
        };
      });
    },
    filteredSections() {
      return this.filteredQuestions?.filter(section => {
        return section.questions?.length || section.slug === 'wizard'
      });
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    $route() {
      window.scrollTo(0, 0);
    },
    clientGroupID: {
      immediate: true,
      handler(id) {
        if (!id) return;
        this.getClientGroupQuestions();
      }
    }
  },
  methods: {
    async getClientGroupQuestions() {
      const url = `/api/v1/client-groups/${this.clientGroupID}/questions`;
      const res = await (await fetch(url)).json();
      this.clientGroupQuestions = res.available_questions;
    },
  },
};
</script>


<style scoped>
.view {
  background-color: #f6f7f8;
}
</style>
